"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export const reference = (name, value, hoverable = true) => {
  return value ? { name, value, hoverable } : {};
};
export const allReferences = function(load) {
  let references = [];
  if (load.customer) {
    references.push(reference(
      "Customer",
      load.customer.name || load.customer.external_id
    ));
  }
  if (load.office) {
    references.push(reference("Office", load.office));
  }
  _.each(load.visible_references, (v, k) => {
    splitReferences(v).map((str) => str.trim()).forEach((ref) => {
      references.push(reference(k, ref, true));
    });
  });
  references = references.map(cleanReference).filter((pair) => pair.value);
  return references;
};
export const splitReferences = (value) => {
  if (value.includes("\u2063")) {
    return value.split(",\u2063");
  } else {
    return value.split(",");
  }
};
export function cleanReference(reference2) {
  return __spreadProps(__spreadValues({}, reference2), {
    value: cleanReferenceValue(reference2.value)
  });
}
export function cleanReferenceValue(value) {
  return value && value.replace("\u2063", "");
}
export default { allReferences, reference };
